<template>
    <div class="p-20">
        <div class="row">
            <div class="col-lg-6">
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Offer Type</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1"><a href="">{{offer.type}}</a></dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>{{offer.type === 'SELL' ? 'Seller': 'Buyer'}}</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1"><a href="">{{offer.name}}</a></dd>
                    </div>
                </dl>
            </div>
            <div class="col-lg-6">
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Status</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">
                            <p v-if="offer.status === 'CREATED'"><span class="label label-cyan">Created</span></p>
                            <p v-if="offer.status === 'ACTIVE'"><span class="label label-info">Active</span></p>
                            <p v-if="offer.status === 'INACTIVE'"><span class="label label-inverse">Inactive</span></p>
                            <p v-if="offer.status === 'NEGOTIATING'"><span class="label label-orange">Negotiating</span></p>
                            <p v-if="offer.status === 'PENDING'"><span class="label label-purple">Pending</span></p>
                            <p v-if="offer.status === 'CONFIRMED'"><span class="label label-light-green">Confirmed</span></p>
                            <p v-if="offer.status === 'SETTLED'"><span class="label label-dark-green">Settled</span></p>
                        </dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Created</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">{{offer.created_at | date}}</dd>
                    </div>
                </dl>
                <dl class="row mb-0" v-if="offer.contract_type === 'FORWARD'">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Expires</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">{{offer.expires_at | date}}</dd>
                    </div>
                </dl>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Commodity</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">
                            <p>{{offer.commodity_name}}</p>
                            <p>{{offer.description}}</p>
                        </dd>
                    </div>
                </dl>
                <dl class="row mb-0" v-if="offer.commodity_props">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Harvest Year</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">{{offer.commodity_props['harvest year']}}</dd>
                    </div>
                </dl>
                <dl class="row mb-0" v-if="offer.commodity_props">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Grade</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">{{offer.commodity_props['grade']}}</dd>
                    </div>
                </dl>
                <dl class="row mb-0" v-if="offer.commodity_props">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Quality</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">{{offer.commodity_props['special quality']}}</dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Quantity</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1" v-if="offer.unit">{{offer.quantity | count}} {{offer.unit.symbol}}</dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Unit Price</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">{{offer.unit_price | money }}</dd>
                    </div>
                </dl>
            </div>
            <div class="col-lg-6" id="cluster_info">
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Contract Type</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">{{offer.contract_type | capitalize}}</dd>
                    </div>
                </dl>
                <dl class="row mb-0" v-if="offer.contract_type === 'FORWARD'">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Maturation</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">Apr 15, 2018</dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Payment</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">Cash Settled</dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Terms</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">Seller agrees to ship above stated quantity to the buyer</dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Provenance</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1" v-if="offer.provenance"><a :href="offer.provenance" target="_blank">{{
                            offer.provenance }}</a></dd>
                        <dd class="mb-1" v-else>NA</dd>
                    </div>
                </dl>
                <dl class="row mb-0">
                    <div class="col-sm-4 text-sm-right">
                        <dt>Audit</dt>
                    </div>
                    <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1" v-if="offer.audit"><a :href="offer.audit" target="_blank">{{
                            offer.audit }}</a></dd>
                        <dd class="mb-1" v-else>NA</dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TradeDocuments",
        props: {
            offerid: String,
            offer: Object
        },
        data(){
            return {
                update_offer: {
                    unit_id: null,
                    quantity: null,
                    unit_price: null
                }
            }
        },
        methods: {
            async update() {
                if(this.offer){
                    try {
                        // this.update_trade.unit_id = this.trade.unit.id;
                        // await this.$http.put(`/trades/${this.trade.trade_id}`, this.update_trade);
                        // await this.$parent.getTrade();
                    } catch (e) {

                    }
                }
            },
            reset(){
                this.update_offer = {
                    unit_id: null,
                    quantity: null,
                    unit_price: null
                }
            }
        }
    }
</script>

<style scoped>

</style>
